export class NoonReportDateTime {
    dateLineCrossed: boolean;
    aolDateLocalTime: string;
    reportFromTimeLocalTime: Date;
    reportToTimeLocalTime: Date;
    reportFromTimeUTC: Date;
    reportToTimeUTC: Date;

    constructor(
        dateLineCrossed: boolean,
        aolDateLocalTime: string,
        reportFromTimeLocalTime: Date,
        reportToTimeLocalTime: Date,
        reportFromTimeUTC: Date,
        reportToTimeUTC: Date
    ) {
        this.dateLineCrossed = dateLineCrossed;
        this.aolDateLocalTime = aolDateLocalTime;
        this.reportFromTimeLocalTime = reportFromTimeLocalTime;
        this.reportToTimeLocalTime = reportToTimeLocalTime;
        this.reportFromTimeUTC = reportFromTimeUTC;
        this.reportToTimeUTC = reportToTimeUTC;
    }
}
